import {atom} from 'jotai/index';

import {
  OMICRON_DEFAULT_RESPONSE,
  OmicronDTO,
} from '@web-catalog/api/omicronApi';

/**
 * принципиальная разница тут такая:
 * - omicronConfigAtom заполняется актуальными значениями тогглов при сервер сайд рендеринге
 * - omicronConfigClientAtom заполняется актуальными значениями после гидрации
 *  (при сервер сайд рендеринге все значения тогглов берутся из фоллбека)
 *  и может быть пропатчен из квери параметров урла
 */
export const omicronConfigAtom = atom<OmicronDTO>(OMICRON_DEFAULT_RESPONSE);

export const omicronConfigClientAtom = atom<OmicronDTO>(
  OMICRON_DEFAULT_RESPONSE,
);
